export default __webpack_public_path__ + "static/media/Tech-Band.45b82d91.png";